<template>
<div class="mapPane" >
      <editable-map v-if="mapInfo"
      ref="map"
      :zoom="zoom"
      :editable="true"
      :maxZoom="zoom+2"
      :minZoom="zoom-2"
      :center="center"
      :options="mapOptions"
      :editOptions= "editOptions"
      :style="'height: calc(100% - 0%); width: 100%'"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
      @update:move="doMove"
      
    >
       <l-tile-layer
        :url="url"
        :attribution="attribution"
      />
      <l-image-overlay 
        :url="mapImage"
        :bounds="imageBounds"
        :attributionControl='false'
       
      />
     
   
     <div  v-for="(loc,l) in locationInfo" :key="'l'+l"> 
      <l-circle   v-if="locationInfo"
      :lat-lng="calcLoc(loc)"
      :radius="loc.radius"
      :color="loc.color"
      :fillOpacity=".2"
      :fillColor="'yellow'"
    />
    </div>
    
    <div  v-for="(loc,l) in locationInfo"  :key="'marker'+l">
      <l-marker
       :lat-lng="calcLoc(loc)"
       :fillColor="loc.color"
       :icon="myIcon(loc.color)"
      >
     
        <l-popup :content="loc.name+' - '+loc.description" />
      </l-marker>
    
      </div>
      <editable-polygon
      v-if="!hideSearchArea"
      ref="poly"
      @click="editMode = editMode"
      :editable="editMode"
      :lat-lngs="latLngs"
      :skipMiddleMarkers="true"
    />
     <div  v-for="(found,f) in foundData" :key="'f'+f"> 
    <l-circle @click="giveFoundInfo(found)"
      :lat-lng="getMapPos(found)"
      :radius="300"
      :color="'orange'"
      :fillOpacity=".0"
      :opacity="showFoundPoints(found)"
      :fillColor="'green'"
    />
    </div>
      <div v-for="(scanned,s) in scannedData" :key="'s'+s">
        <l-circle
          :lat-lng="getMapPos(scanned)"
          :radius="0.1"
          :color="'white'"
          :fillOpacity="showSearchPoint(s)"
          :opacity="showSearchPoint(s)"
          :fillColor="'white'"
        />
     </div>
     
      <div v-if="map && scanData.b>100 && false">
        <l-circle
          :lat-lng="shipPos"
          :radius="300"
          :color="'white'"
          :fillOpacity=".5"
          :fillColor="'yellow'"
        />
     </div>
      <div v-if="false" >
       <v-path-transform 
        v-for="(latLng, index) in latLngs"
        :key="index"
        :latLngs="latLng"
        :draggable='true'
        :rotation='true'
        :scaling='true'
        :uniformScaling='false'
       
        color='#ffffff'
        fillColor="#00ff00"
        :fillOpacity="0.3"
        
        dashArray='[]'
        :handlerOptions="handlerOptions"
        @transformed='handlePathTransformed'>
    </v-path-transform>
    e
     </div>
     
    </editable-map>
    <div v-if="false" style="position:absolute;bottom:40px;z-index:3000"> {{currentCenter}}</div>
    <div v-if="false" class="mapKey">
     
    Key<br>
    <div v-for="key in locationInfo" :key="key.id">
      <div v-if="!key.hideKey">
      <div  class="keyDot" :style="'border:solid 2px '+key.color+';'"></div>{{key.name}}
      </div>
    </div>
  </div>
   <DepthMap style="display:none;" ref="depthScan" v-if="(enableScan || mapEnabled) && source" :source="source" @searchUpdate="searchUpdate" @preScanFinished="preScanFinished"  @FoundSomething="doFound" :polygon="polygon" class="windowed"></DepthMap>
    <div v-if="false" class="windowed" style="font-size:40px;color:#fff;font-weight:900;opacity:1;">{{polygon}}
      <img :src="source" width="500px"/>
    </div>
      </div>
      
</template>

<script>
import { latLng } from "leaflet";

import Vue2LeafletPathTransform from 'vue2-leaflet-path-transform'
import LeafletMeasurePath from 'leaflet-measure-path'
import LeafletEditable from 'leaflet-editable'
import LeafletPathDrag from'leaflet.path.drag'
import { EditableMap, EditablePolygon } from 'vue2-leaflet-editable'
import Maps from '@/mixins/maps'
import DepthMap from '@/components/DepthMap'
import sourceA from "@/assets/images/maps/depthBermagui.png"
import source1 from "@/assets/images/maps/bomberDepth4.png"
import source from "@/assets/images/maps/depthEnterprise.png"
import source3 from "@/assets/images/maps/depthPandemonium.png"
import source4 from "@/assets/images/maps/depthVerdoemd.png"

export default {
  name: "LeafletMap",
  mixins:[Maps],
  components: {
   'v-path-transform': Vue2LeafletPathTransform,EditableMap, EditablePolygon,DepthMap
  },
  props:{
    hideSearchArea:{default:false},
    enableScan:{default:false},
    width:{default:300},
    mapHeightOffset:{defalut:180}
  },
  data() {
    var cntLat=-12.271573
    var cntLon=136.842957
    var size=.05
    
    var latLngs = [
        [
          [cntLat+size,cntLon-size],
          [cntLat+size,cntLon+size*2],
          [cntLat-size,cntLon+size],
          [cntLat-size,cntLon-size],
        ]
    
       ];
    return {
      searchArea:0,
      foundSpots:[],
      foundInfo:[],
      source:null,
      firebasePath:null,
      imageSize:{w:864,h:540},
      editMode:false,
      a:null,
      latLngs,
      colors:['#ffff00','#ffff00'],
      handlerOptions: {
        radius: 5,
        weight: 1.5,
        color: '#002000',
        uniformScaling:false
      },
      
      stepValue:1,
      BRV:0,
      TLV:0,
      TLH:0,
      BRH:0,
     
      //center: latLng(47.41322, -1.219482),
       url:' https://api.mapbox.com/styles/v1/formula7/ck8az16v616us1ik95m20fy9n/draft/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZm9ybXVsYTciLCJhIjoiY2pybGVpeTh1MDdydzN5cjJ6aHo2cDlhMiJ9.na1OKOKSLJGOEDxHCuSzAw',
     
      //url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      
      currentZoom: 12,
      currentCenter: latLng(-12.271573, 136.842957),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      editOptions: {skipMiddleMarkers: true},
      showMap: true,
      map:null,
      mapInitiated:false,
      polygon: [[ 200, 50 ], [ 400, 150 ], [ 450, 300 ], [ 260, 600 ]],
      scannedPoints:[],
      pointIndex:0,
      scannedIndex:0,
      lastFound:0,
      lastFoundIndex:-1,
      revealInterval:null,
      searchIndex:1,
      hasScale:false,
      dragCount:0,
      mapEnabled:false,
    };
  },
  mounted(){
    this.firebasePath=this.fireBaseLoc+"/wrecks%2F"
    console.log("LEAFLET MAP MOUNTED",this.mapInfo,this.source,this.enableScan)
    this.dragCount=0
   
    this.doMounted()
    
  },
  computed:{
    fireBaseLoc(){
					return this.$store.getters.getFireBaseLoc					
			},
    shipPos(){
      if(this.map){
      let x=this.scanData.x*this.dWidth/this.imageSize.w+this.topLft.x
      let y=this.scanData.y*this.dHeight/this.imageSize.h+this.topLft.y
      return this.map.layerPointToLatLng([x,y])
      }
    },
    scannedData(){
      return this.$store.getters.getScannedData
    },
    foundData(){
      return this.$store.getters.getFoundData
    },
    scanData(){
      return this.$store.getters.getScanData
    },
    topLft(){
      return this.map.latLngToLayerPoint(this.imageBounds[0])
    },
    botRgt(){
      return this.map.latLngToLayerPoint(this.imageBounds[1])
    },
    dWidth(){
      return this.botRgt.x-this.topLft.x
    },
    dHeight(){
      return this.botRgt.y-this.topLft.y
    },
    
    mapArea(){
      let sa=this.$store.getters.getWreckSearchArea
      if(sa){
       console.log("SEARCH AREA")
        return [{lat:sa[0],lng:sa[1]},{lat:sa[2],lng:sa[3]},{lat:sa[4],lng:sa[5]},{lat:sa[6],lng:sa[7]}]
      }
      console.log("--- NO MAP AREA")
      //return null
      return this.$store.getters.getMapArea 
    },
    mapID(){
      if(this.mapInfo){
        return this.mapInfo.id
      }
      
    },
    zoom(){
       if(this.mapInfo){
         return parseInt(this.mapInfo.zoom,10)
         return Math.floor(40000000/this.mapInfo.width)
       }
       return 12
    },
    stepDetail(){
      return Math.pow(10,this.stepValue-(this.zoom-1))
    },
    imageBounds(){
          if(this.mapInfo){
           
        this.TLV=this.mapInfo.tl.lat
        this.TLH=this.mapInfo.tl.lon
        this.BRV=this.mapInfo.br.lat
        this.BRH=this.mapInfo.br.lon
     
            console.log("imageBounds",[[this.TLV,this.TLH],[this.BRV,this.BRH]])
            return [[this.TLV,this.TLH],[this.BRV,this.BRH]]
          }
      return [[-12.159387,136.782969], [-13,138]]
    },
    center(){
          if(this.mapInfo){
            if(this.mapInfo.mapStart){
              let mp=this.mapInfo.mapStart.split(",")
              return latLng(mp[0],mp[1])
            }else{
              return latLng((this.mapInfo.tl.lat+this.mapInfo.br.lat)/2,(this.mapInfo.tl.lon+this.mapInfo.br.lon)/2)
            }
          }
       return latLng(-12.271573, 136.842957)
     },
    minZoom(){
      if(this.mapInfo){
         return Math.floor( -this.mapInfo.width/5000) || -10
      }
     retturn -10
    },
    mapSize(){
      if(this.mapInfo){
        return this.mapInfo.width || 5000
      }
      return 5000
    },
    getMapZones(){
      return this.$store.getters.getMapZones("map001")
    },
    getLocations(){
      console.log("----- --- -- Get Locations")
      let locs=[]
      if(this.mapInfo){
      for(var l in this.mapInfo.locations ){
        this.$store.dispatch('loadLoc',this.mapInfo.locations[l].id)
        locs.push(l)
      }
      console.log("LOCATIONS",locs)
      return locs
      }
    },
    
    mapInfo(){
     
      return this.$store.getters.getCurrentMap
    },

     mapImage(){
      
      if(this.mapInfo.image){
        let mapInfo=this.mapInfo.image.split("|")
        if(mapInfo.length>0){
          return mapInfo[1]
        }
        
        return require("../assets/images/maps/"+this.mapInfo.image) 
      }
        return null
      
    },
    
    bounds(){
      return [[Math.floor(-this.mapSize*.5),Math.floor(-this.mapSize*.5*this.ratio)], [Math.floor(this.mapSize*.5),Math.floor(this.mapSize*.5*this.ratio)]]
    },
    maxBounds(){
      return [[Math.floor(-this.mapSize*.5),Math.floor(-this.mapSize*.5*this.ratio)], [Math.floor(this.mapSize*.5),Math.floor(this.mapSize*.5*this.ratio)]]
  
    },
    
    
  },
  methods:{
    hasMap(val){
       console.log("WATCH MAP INFO",val)
      this.$nextTick(() => {
         if(this.$refs.map){
            this.map=this.$refs.map.mapObject
         }
         console.log("WATCH MAP INFO2",val)

       if(val && val.depthMap){
         //this.source=this.firebasePath+val.depthMap
          this.source=require("../assets/images/maps/"+val.depthMap)
          console.log("THE MAP ../assets/images/maps/"+val.depthMap)
        }
         if(val && this.mapArea[0].lat>val.tl.lat ||  val && this.mapArea[0].lat<val.br.lat || val && this.mapArea[0].lng<val.tl.lon ||  val && this.mapArea[0].lng>val.br.lon){
         
          this.adjustArea(true)
        }
      })
      
      
      if(val && this.$refs.map){
        this.setOffsets()
        this.$refs.map.mapObject.setView(L.latLng(this.center.lat, this.center.lng), val.zoom);
       
        this.doResize()
       
      }
    },
    setEnabled(val){
      if(this.mapInfo){
        this.source =require("../assets/images/maps/"+this.mapInfo.depthMap)
      }
      
      this.mapEnabled=val
    },
    setMapInfo(val){
      //console.log("SET MAP INFO", this.mapInfo,val)
    },
    doMounted(){
      console.log("MOUNTED",this.mapInfo)
      if(this.mapInfo ){
        this.setOffsets()
        this.$nextTick(() => {
        if(this.$refs.map){
           this.map=this.$refs.map.mapObject
        }
       
        if(!this.mapInitiated){
          this.initMap()
        }
      })
    }
    if(this.getLocations){
      //console.log("Locations",this.getLocations)
    }
     console.log("MAP AREA ",this.mapArea,this.mapInfo)
      if(this.mapArea){ 
        this.latLngs=[[this.mapArea[0].lat,this.mapArea[0].lng],[this.mapArea[1].lat,this.mapArea[1].lng],[this.mapArea[2].lat,this.mapArea[2].lng],[this.mapArea[3].lat,this.mapArea[3].lng]]
        this.adjustArea()        
      }else{
        if(this.mapInfo ){
          this.adjustArea()
        }
      }
      
    },
    myIcon(color){
      return L.divIcon({className: 'mIcon '+color})
    },
    showPoints(){
       this.revealInterval=window.setInterval(this.nextPoint,1000);
    },
    showFound(){
      this.pointIndex=this.scannedIndex
      this.foundData[this.scannedData[this.scannedIndex].findIndex].revealed=this.searchIndex
    },
    showSearchedPoints(){
       this.pointIndex=this.scannedIndex
    },
    nextPoint(){
     
      if(this.pointIndex<this.scannedData.length-1){
         this.pointIndex++
         this.scannedIndex=this.pointIndex
         if(this.scannedIndex-this.lastFound>5){
           while(this.scannedIndex<this.scannedData.length-1 && this.scannedData[this.scannedIndex].findIndex==-1){
             this.scannedIndex++
           }
           console.log("look ahead to",this.scannedIndex,this.scannedData.length,this.searchIndex,this.scannedData[this.scannedIndex])
         }
         if( this.scannedIndex>=this.scannedData.length-1){
            window.clearInterval(this.revealInterval)
            setTimeout(this.showSearchedPoints,1000)
            this.$emit("scanFinished",this.scannedIndex-this.lastFound)
           
         }
         //console.log( this.pointIndex)
         if(this.scannedData[this.scannedIndex].findIndex>-1){
            console.log("found something",this.scannedIndex,this.searchIndex,this.foundData[this.scannedData[this.scannedIndex].findIndex].revealed)
            if(this.foundData[this.scannedData[this.scannedIndex].findIndex].revealed!=this.searchIndex){
                window.clearInterval(this.revealInterval)
                setTimeout(this.showFound,1000)
               //this.foundData[this.scannedData[this.scannedIndex].findIndex].revealed=true
               console.log("PRE FOUND",(this.scannedIndex,this.lastFound))
               this.$emit("foundLoc",this.scannedData[this.scannedIndex],this.scannedIndex-this.lastFound)
               this.lastFound=this.scannedIndex
            }else{
              this.pointIndex=this.scannedIndex
            }
          }
      }else{
        window.clearInterval(this.revealInterval)
        this.$emit("scanFinished",0)
      }
     
      
      
      
    },
    showFoundPoints(found){
      if(found.revealed){
        return 1
      }else{
         return .1
      }
    },
    showSearchPoint(index){
      if(this.pointIndex>index){
        return 0.5
      }else{
        return 0
      }
    },
    giveFoundInfo(point){
      console.log("found point",point)
    },
    preScan(){
      
      console.log("========= == = = = =Pre Scan",this.$refs.depthScan,this.enableScan,this.source)
      this.lastFound=0
      this.pointIndex=0
      this.scannedIndex=0
      this.lastFoundIndex=-1
     
        console.log("SOURCE",this.source)
        //this.$refs.depthScan.doMove=true
        this.$refs.depthScan.startScan()
      
    },
    startPlot(){
      
      this.$refs.depthScan.doMove=true
      //this.$refs.depthScan.moveSpeed=10
    },
    stopPlot(){
      this.$refs.depthScan.doMove=false
      this.$refs.depthScan.stopScan()
      //this.$refs.depthScan.moveSpeed=.1
    },
     slowPlot(){
      this.$refs.depthScan.doMove=false
      //this.$refs.depthScan.moveSpeed=.1
    },
    pointToPos(pt){
      return [ Math.round((pt.x-this.topLft.x)/this.dWidth*this.imageSize.w),  Math.round((pt.y-this.topLft.y)/this.dHeight*this.imageSize.h )]
    },
    adjustPolygon(){
       if(this.poly && this.map){
          this.polygon= [this.pointToPos(this.map.latLngToLayerPoint(this.poly._latlngs[0][0])), this.pointToPos(this.map.latLngToLayerPoint(this.poly._latlngs[0][1])), this.pointToPos(this.map.latLngToLayerPoint(this.poly._latlngs[0][2])),this.pointToPos(this.map.latLngToLayerPoint(this.poly._latlngs[0][3]))]
        }
     },
     handlePathTransformed(path) {
       let points=path.sourceTarget.getLatLngs()
        let x1=points[0][0].lat
        let y1=points[0][0].lng
        let x2=points[0][1].lat
        let y2=points[0][1].lng
        let x3=points[0][2].lat
        let y3=points[0][2].lng
        let x4=points[0][3].lat
        let y4=points[0][3].lng
      let area= .5*(x1*y2 + x2*y3 + x3*y4 + x4*y1)- (x2*y1 + x3*y2 + x4*y3 + x1*y4)
     
    },
    getZoom(){
      return this.zoom
    },
    getCenter(){
      return this.center
    },
    closeMap(){
      this.$emit('hideMap')
    },
    setOffsets(){
      console.log("-----SET OFFSETS",this.mapInfo)
      if(this.mapInfo){
        this.TLV=this.mapInfo.tl.lat
        this.TLH=this.mapInfo.tl.lon
        this.BRV=this.mapInfo.br.lat
        this.BRH=this.mapInfo.br.lon
      }
      this.adjustPolygon()
      
    },
    stepChanged(){
      //alert("CHANGE")
    },
    tlDown(){
      this.TLV-=.01/this.stepDetail
    },
    tlUp(){
      this.TLV+=.01/this.stepDetail
    },
    tlLeft(){
      this.TLH-=.01/this.stepDetail
    },
    tlRight(){
      this.TLH+=.01/this.stepDetail
    },
    brDown(){
      this.BRV-=.01/this.stepDetail
    },
    brUp(){
      this.BRV+=.01/this.stepDetail
    },
    brLeft(){
      this.BRH-=.01/this.stepDetail
    },
    brRight(){
      this.BRH+=.01/this.stepDetail
    },
    calcLoc(loc){
       let newLoc={}
           newLoc.lat=loc.lat
           newLoc.lng=loc.lon
           return newLoc
    },
    calcZone(zone){
      let newZone={}
      if(this.mapInfo){
        newZone.lat=zone.lat
        newZone.lng=zone.lng
        return newZone
      }
      return zone
    },
    doResize(){
      
      this.$refs.map.mapObject.invalidateSize()
    },
    activatePanel(){
      this.$refs.map.mapObject.invalidateSize()
      this.$emit('activateMap')
    },
    zoneStyle(zone){
      return "top:"+zone.lat+"px;left:"+zone.lng+"px;width:"+zone.size+"px;height:"+zone.size+"px;"
    },
    doUpdate(){
     this.$emit('mapChange',this.currentZoom,this.currentCenter)
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
      this.doUpdate()
    },
    centerUpdate(center) {
      this.currentCenter = center;
      this.doUpdate()
    },
    doMove(event){
     
      this.doUpdate()
    },
    drag(event){
      //console.log("Poly Drag")
      
      this.poly.updateMeasurements()
     
      this.adjustPolygon()
      this.polyChange()
     
     console.log(this.poly._latlngs[0][0].lat)
     this.$emit('doPolyMove')
      //return
     
       return
      
    },
    dragUp(){
      console.log("DRAG UP")
      this.$store.commit("setMapArea",this.poly._latlngs[0])
      
      this.$store.commit("setWreckMapArea",this.poly._latlngs[0])
    },
    doPolyClick(event){
      console.log("POLY",event.latlng.lat+","+event.latlng.lng)
      console.log("POLY",this.poly._measurementLayer._layers)
      
      event.cancel();
    },
    polyChange(){
      console.log("Poly Change")
      let polyLayers=this.poly._measurementLayer._layers
      for(var i in polyLayers){
        if(polyLayers[i]._measurement.indexOf("km²")>0){
           this.searchArea=polyLayers[i]._measurement.split(" ")[0]
           
           this.$emit('polyChange',this.searchArea)
           polyLayers[i]._measurement=""
        }
       

      }
      
    },
    saveArea(){
      this.polyChange()
      return
      
    },
    adjustArea(force){
     
          var size=.0225
          var ratio=1.25
          if(!this.mapArea || force){
            this.latLngs= [
                    [
                      [this.center.lat+size,this.center.lng-size*ratio],
                      [this.center.lat+size,this.center.lng+size*ratio],
                      [this.center.lat-size,this.center.lng+size*ratio],
                      [this.center.lat-size,this.center.lng-size*ratio],
                    ]
                ]
          }else{
            
             if(this.mapInitiated && this.map){
                //alert("polyChange")
                this.polyChange()
             }
          }
          
    },
    initMap(){
      console.log("INIT MAP")
      if(!this.mapInitiated && this.map){
       
           this.map.editable=true
           this.map.editTools.options.skipMiddleMarkers=true
          
          if(!this.hasScale){
              L.control.scale({imperial:false}).addTo(this.map);
              this.hasScale=true
          }
        
       
          //this.map.removeScaleBar()
          if(this.$refs.poly){
    
     this.poly=this.$refs.poly.mapObject
     this.poly.showMeasurements()
    
      this.poly.enableEdit();
      this.poly.on("editable:editing",this.drag)
      this.poly.on("drag",this.drag)
      this.poly.on("mouseup",this.dragUp)
      this.poly.on("editable:vertex:click",this.doPolyClick)
      //this.poly.on("editable:vertex:dragend",this.dragUp)
      
      this.poly.dragging.enable()
      
      //this.poly.editOptions= this.editOptions
       this.adjustPolygon()
       this.polyChange()
       this.$emit('doPolyMove')
        }
         this.mapInitiated=true
      }
    },
    preScanFinished(){
      
    },
    scanFinished(){
     this.$emit("scanFinished")
    },
    searchUpdate(val,x,y){
      this.scannedPoints.push(val,x,y)
      this.$emit("searchUpdate",val,x,y)
      
    },
    doFound(val,x,y){
      val=Math.ceil(val*.1)*10
      var isFound=false;
      for(var f in this.foundInfo){
        if(this.foundInfo[f].val==val){
          console.log("already found")
          isFound=true
        }
      }
      if(isFound){
        this.$refs.depthScan.doMove=true
        return
      }
      x=x*this.dWidth/this.imageSize.w+this.topLft.x
      y=y*this.dHeight/this.imageSize.h+this.topLft.y
      this.foundSpots.push(this.map.layerPointToLatLng([x,y]))
      this.foundInfo.push({val:val,x:x,y:y})
      // this.$refs.depthScan.moveSpeed=1
      console.log("DO FOUND",this.scannedIndex-this.lastFound)
      this.$emit("foundLoc",val)
     
    },
    getMapPos(pos){
      if(this.map){
      let x=pos.x*this.dWidth/this.imageSize.w+this.topLft.x
      let y=pos.y*this.dHeight/this.imageSize.h+this.topLft.y
      return this.map.layerPointToLatLng([x,y])
      }
    }
   
  },
  watch:{
    locationInfo(val){
      
     
    },
    // log all watchers *******
    mapArea(val,old){
      //console.log("mapArea WATCH",val,old)
      if(this.mapArea && !old){ 
        this.latLngs=[[this.mapArea[0].lat,this.mapArea[0].lng],[this.mapArea[1].lat,this.mapArea[1].lng],[this.mapArea[2].lat,this.mapArea[2].lng],[this.mapArea[3].lat,this.mapArea[3].lng]]
        this.adjustArea()    
      }
    },
    map(){
      console.log("WATCH MAP")
       this.mapInitiated=false
       this.initMap()
    
        
    },
    mapID(val){
      
    },
    mapInfo(val){
      this.doMounted()
      this.hasMap(val)
      
    
     
    },
    enableScan(val){
      console.log("***** Enable Scan",val)
    },
    source(val){
      console.log("***** Source",val)
    },
    center(val){
      console.log("WATCH MAP CENTER", this.mapInitiated)
      if(!this.mapInitiated){
        this.currentCenter=val
        this.adjustArea()
      }
      
    }
  },
  beforeDestroy () {
    
    if(this.poly && this.poly._latlngs){
    this.$store.commit("setMapArea",this.poly._latlngs[0])
      
      this.$store.commit("setWreckMapArea",this.poly._latlngs[0])
    }
     //this.saveArea()
     
},
  
};
</script>

<style lang="scss">
.windowed{
  position:absolute;
 z-index:2000;
  transform:scale(.4);
  opacity:0.5;
  right:400px;
  top:0px;
  
}
.leaflet-measure-path-measurement {
    position: absolute;
    font-size: 16px;
    color: #fff;
    text-shadow: 0px  0px 10px #000,0px  0px 10px #000,0px  0px 10px #000;
    /*text-shadow: -1px  0 0 white,
                 -1px -1px 0 white,
                  0 -1px 0 white,
                  1px -1px 0 white,
                  1px  0 0 white,
                  1px  1px 0 white,
                  0  1px 0 white,
                 -1px  1px 0 white;
                 */
    white-space: nowrap;
    transform-origin: 0;
    pointer-events: none;
}

.leaflet-measure-path-measurement > div {
    position: relative;
    margin-top: -25%;
    left: -50%;
}
[title='Total area']{
  opacity:0;
}
.leaflet-container {
    background: #0e3032!important;
}
.leaflet-control-attribution{
  display:none;
}
.map {
  position:relative;
  width: 100%;

}
.mapImage{
  position: relative;
  overflow: hidden;
  width:100%;
  height:600px;
  background-size: cover;
  
}
.zone{
  position:absolute;
  top:200px;
  left:200px;
  width:300px;
  height:300px;
  background-color:#ff8d0070;
  border: #00ffff solid 2px;
  border-radius:50%;
}

.mIcon{
  width:10px!important;
  height:10px!important;
  border-radius:100%;
  background-color:#fff;
}
.mIcon.blue{
  background-color:blue;
  }
.mIcon.red{background-color:red;}
.mIcon.orange{background-color:orange;}
.mIcon.yellow{background-color:yellow;}
.mIcon.green{background-color:green;}
.mIcon.purple{background-color:purple;}
.mIcon.pink{background-color:rgb(255, 164, 250);}
.mIcon.brown{background-color:brown;}
.mIcon.lime{background-color:lime;}
.mIcon.violet{background-color:violet;}

.mapPane{
 height:calc(100% - 0px);
}
.leaflet-bar a{
    color: #08f5f2;
    background-color: #021c1c;
}
.leaflet-control-scale-line{
    color: #08f5f2;
    background-color: #021c1c;
    border: 2px solid #08f5f2;
    font-family: "Orbitron";
    font-weight:600;
    border-top: none;
    line-height: 1.1;
    padding: 2px 5px 1px;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
 
}
.mapKey{
  background-color: #0009;
    padding: 5px 10px;
    text-shadow: black 0px 0px 8px;
    color: #06dbff;
    position: absolute;
    text-align:left;
    bottom: 100px;
    font-weight: 500;
    font-size: 18px;
    left: 30px;
    text-transform: uppercase;
    z-index: 1001;
    pointer-events: none;
}
.keyDot{
  width:12px;
  height:12px;
  border-radius:50%;
  display:inline-block;
  background-color:#fff3;
  margin-right:10px;
}
</style>